export default {"src":"/_next/static/media/FakeDevice1A.febc1d7e.svg","height":82,"width":160,"blurWidth":0,"blurHeight":0};